import React from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import SkillList from './SkillList';
import SkillDetail from './SkillDetail';
import './training.css';

function Flame() {
  return (
    <svg className="tr-topbar-flame" width="28" height="34" viewBox="0 0 32 40" fill="none" aria-hidden="true">
      <path d="M16 2C16 2 8 10 8 18C8 22.4 10.4 26.2 14 28.4C13.2 26.8 13 25 13.4 23.2C14.6 25 16.4 26.2 18 26C17 24 17.2 21.6 18.8 20C19.6 22 20.8 23.4 22 24C22 20 20 16.4 16 14C17.6 16.4 18 19.2 16.8 22C15.2 20 14.4 17.2 15.2 14.4C13.2 16.4 12 19.4 12.4 22.6C10.4 20.4 9.6 17.2 10.4 14C9.2 16 8.4 18.4 8.8 20.8C8.2 19.8 8 18.6 8 17.4C8 23.4 11.6 28.4 17 30C17.4 30.2 17.8 30.2 18.2 30.4C22.6 28.6 26 24.4 26 18C26 10 18 2 16 2Z" fill="#f97316"/>
    </svg>
  );
}

export function TopBar({ title, subtitle, showBack }) {
  const navigate = useNavigate();
  return (
    <div className="tr-topbar">
      {showBack ? (
        <button
          className="tr-topbar-back"
          onClick={() => navigate('/training')}
          aria-label="Back to skill list"
        >
          ‹
        </button>
      ) : (
        <Flame />
      )}
      <div className="tr-topbar-titles">
        <span className="tr-topbar-title">{title}</span>
        {subtitle && <span className="tr-topbar-subtitle">{subtitle}</span>}
      </div>
    </div>
  );
}

function ListPage() {
  return (
    <>
      <TopBar title="Fireground Training" subtitle="NFPA 1010 Skill Sheets" showBack={false} />
      <SkillList />
    </>
  );
}

export default function TrainingApp() {
  return (
    <div className="tr-app">
      <Routes>
        <Route index element={<ListPage />} />
        <Route path="skill/:id" element={<SkillDetail TopBar={TopBar} />} />
        <Route path="*" element={<ListPage />} />
      </Routes>
    </div>
  );
}
